import * as THREE from 'three';
import TWEEN from 'tween.js';

import Wall from 'entities/wall';

export default class Arena extends THREE.Group {
  constructor () {
    super();
    this._minSpacing = 200;
    this._maxSpacing = 800;
    this._direction = 1;
    this.loops = true;

    this.rightWall = new Wall({
      width: 20,
      height: 100,
      depth: 1000,
      position: new THREE.Vector3(400, 50, -350),
      colour: 0x33FF00,
      activeFace: 'left'
    });
    this.add(this.rightWall);

    this.leftWall = new Wall({
      width: 20,
      height: 100,
      depth: 1000,
      position: new THREE.Vector3(-400, 50, -350),
      colour: 0x33FF00,
      activeFace: 'right'
    });
    this.add(this.leftWall);
  }

  narrowBy (amount) {
    const interDistance = this.rightWall.position.x - this.leftWall.position.x;
    if (
      (interDistance <= this._minSpacing  && this._direction > 0) ||
      (interDistance >= this._maxSpacing && this._direction < 0)
    ) {
      if (this.loops) {
        this._direction *= -1;
      }
    };

    new TWEEN.Tween(this.rightWall.position)
      .to({x: this.rightWall.position.x - amount * this._direction}, 250)
      .start();

    new TWEEN.Tween(this.leftWall.position)
      .to({x: this.leftWall.position.x + amount * this._direction}, 250)
      .start();
  }

  reset () {
    new TWEEN.Tween(this.rightWall.position)
      .to({x: 400}, 500)
      .start();

    new TWEEN.Tween(this.leftWall.position)
      .to({x: -400}, 500)
      .start();
  }

  hitWall (object) {
    let hit = null;
    let objAABB = new THREE.Box3().setFromObject(object);
    let leftWallAABB = new THREE.Box3().setFromObject(this.leftWall);
    let rightWallAABB = new THREE.Box3().setFromObject(this.rightWall);

    if (objAABB.intersectsBox(leftWallAABB)) {
      hit = 'left';
    } else if (objAABB.intersectsBox(rightWallAABB)) {
      hit = 'right';
    }
    return hit;
  }
}



// WEBPACK FOOTER //
// ./src/entities/arena.js